import React, { createContext, useState, useEffect } from 'react';
const UserContext = createContext();

function getUserIdentifier() {
  let userId = localStorage.getItem('userId');
  if (!userId) {
    userId = 'user_' + Math.random().toString(36).substr(2, 9)
    localStorage.setItem('userId', userId);
  }
  return userId;
}

export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState('');

  useEffect(() => {
    setUserId(getUserIdentifier());
  }, []);

  return (
    <UserContext.Provider value={{ userId }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => React.useContext(UserContext);
